import { MenuItem } from "@mui/material";
import { OrganizationProductType } from "generated/graphql";
import { Link } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function CreateProduct({
  closeMenu,
  id,
}: {
  closeMenu: () => void;
  id: OrganizationProductType["id"];
}) {
  return (
    <MenuItem
      component={Link}
      onClick={closeMenu}
      to={getRoute("product-types.products.create", [["productTypeId", id]])}
    >
      Create product
    </MenuItem>
  );
}
